/**
 * 数字に3桁区切りのカンマを打ちます
 * 
 * @param int num 数字
 * @return string numにカンマを付与した文字列
 */
function addComma(num){
    return String(num).replace( /(\d)(?=(\d\d\d)+(?!\d))/g, '$1,');
}

/**
 * datetime型文字列を「yyyy年mm月dd日」形式に変換します
 * 
 * @param string datetime datetime型文字列
 * @return string 「yyyy年mm月dd日」形式の文字列
 */
function formatDate(datetime) {
    const date = new Date(datetime);

    // 日付が無効かどうかのチェック
    if (isNaN(date.getTime())) {
        return '-年-月-日';
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JavaScriptの月は0から始まるため、1を足して正しい月を取得
    const day = date.getDate();

    return `${year}年${month}月${day}日`;
}

/**
 * datetime型文字列を「yyyy年mm月dd日 hh:mm」形式に変換します
 * @param string datetime datetime型文字列
 * @return string 「yyyy年mm月dd日 hh時mm分」形式の文字列
 */
function formatDatetime(datetime) {
    const date = new Date(datetime);

    // 日付が無効かどうかのチェック
    if (isNaN(date.getTime())) {
        return '-年-月-日 --時--分';
    }

    const year = date.getFullYear();
    const month = date.getMonth() + 1; // JavaScriptの月は0から始まるため、1を足して正しい月を取得
    const day = date.getDate();
    const hour = date.getHours();
    const minute = date.getMinutes();

    return `${year}年${month}月${day}日 ${hour}時${minute}分`;
}

/**
 * datetime型文字列から残日数を計算します
 * @param string datetime datietime型文字列
 * @return int 残日数
 */
function calcRemainingDays(datetime) {
    const date = new Date(datetime);
    // 日付が無効かどうかのチェック
    if (isNaN(date.getTime())) {
        return 0;
    }
    // 現在日時を取得
    const now = new Date();
    // 残日数を計算
    const remainingDays = Math.ceil((date.getTime() - now.getTime()) / (1000 * 60 * 60 * 24));

    if(remainingDays < 0) return 0;
    return remainingDays;
}

/**
 * 指定したURLに遷移する
 * @param string url 遷移先URL
 * @param object router VueRouter
 */
function navigateTo(url) {
    location.href = url;
}

/**
 * 文字列に含まれるHTMLタグとノーブレークスペースを取り除きます
 * 
 * @param string str 削除前の文字列
 * @return string 削除後の文字列
 */
function removeHtmlTags(str){
    return str.replace(/&[A-Za-z]{4};|<[^>]+>/g, '');
}

/**
 * 文字列内のHTMLエスケープされた文字をデコードします
 * 
 * @param string str デコード前の文字列
 * @return string デコード後の文字列
 */
function decodeHtmlEscape(str){
    if(!str) return str;
    return str.replace(/&[A-Za-z]{2,4};/g, function (match) {
        switch (match) {
            case '&amp;':
                return '&';
            case '&lt;':
                return '<';
            case '&gt;':
                return '>';
            case '&quot;':
                return '"';
            default:
                return match;
        }
    });
}

/**
 * htmlドキュメント文字列の中から最初のimgタグのsrc属性を取得します
 * 
 * @param string htmlString htmlドキュメント文字列
 * @return string imgタグのsrc属性値、存在しない場合はnull
 */
function getFirstImageSrc(htmlString){
    // DOMParserを使用してHTML文字列を解析
    var parser = new DOMParser();
    var doc = parser.parseFromString(htmlString, 'text/html');

    // 最初のimgタグを取得
    var firstImage = doc.querySelector('img');

    // imgタグが存在する場合、そのsrc属性を返す
    return firstImage ? firstImage.getAttribute('src') : null;
}

export default {
    addComma,
    formatDate,
    formatDatetime,
    calcRemainingDays,
    navigateTo,
    removeHtmlTags,
    getFirstImageSrc,
    decodeHtmlEscape
  };